import styled from 'styled-components';
import { Button } from '@insurancemenu/imenu-components-lib';

export const FooterStyled = styled.footer`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin: 6.4rem auto 10rem;
`;

export const ContinueButtonsWrapperStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
`;

export const ActionButtonStyled = styled(Button)`
  padding: 0;
`;
